/*
  import { unitGroupStore } from '@/services/UnitGroup/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await unitGroupStore.dispatch ('getUnitGroupList', {
      hoaID
    });
  */

  async getUnitGroupList({}, { hoaID }) {
    console.log('in getUnitGroupList...' + hoaID)

    if (hoaID !== undefined) {
      let path = `?hoaID=${hoaID}`

      try {
        const results = await kms.get(`/Roster/UnitGroup/List${path}`)

        if (isDebug == true) console.debug('getUnitGroupList log=' + JSON.stringify(results))

        return {
          list: results.results
        }
      } catch (exception) {
        notifyProblem(`The unit group list could not be retrieved.`)
        console.error(exception)
      }
    }

    return {
      list: []
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const unitGroupStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
